import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSharedModule } from '@fuse/shared.module';
import { ListModule } from 'app/components/list/list.module';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { AuditComponent } from './audit/audit.component';
import { AuditsComponent } from './audits/audits.component';

@NgModule({
    declarations: [
        AuditComponent,
        AuditsComponent,
    ],
    imports: [
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatDialogModule,
        MatToolbarModule,
        CommonModule,
        ListModule,
        FuseSharedModule,
        PhoenixPipesModule,
    ],
    exports: [
        AuditsComponent,
    ],
    providers: []
})
export class AuditComponentsModule {}
